export enum EDocumentType {
  Sales = 'sales',
  HR = 'hr',
  Presentation = 'presentation',
  Other = 'other',
}
